import React, { useState, useEffect, useLayoutEffect, useCallback, useRef, useMemo } from "react";
import { INDEX_URL, CUST, icons, FLAVOR } from "../helpers/constants";
import * as request from "../services/FetchService";
import DragComponent from "../components/DragComponent";
import AddDevice from "../components/Modals/AddDevice";
import OverrideModal from "../components/Modals/OverrideModal";
import { useTranslation } from "react-i18next";
import Button from "../components/Buttons/Button";
import Searchbar from "../components/Searchbar/Searchbar";
import { checkToken, staticSort } from "../helpers/helperFunctions";
import { Card, Collapse } from "@mui/material";
import DeviceRowNew from "../components/Devices/DeviceRowNew";
import SelectedDevice from "../components/Devices/SelectedDevice";
import DeviceRowPlaceholder from "../components/Devices/DeviceRowPlaceholder";
import { useIntervalWhenVisible, useIsMobile } from "../helpers/customHooks";
import toast from "react-hot-toast";
import GroupRow from "../components/Groups/GroupRow";
import CreateGroup from "../components/Groups/CreateGroup";
import SearchbarNew from "../components/Searchbar/SearchbarNew";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import GroupModal from "../components/Modals/GroupModal";
import { useSidebarContext } from "../components/Sidebar/SiderbarContext";
import NewButton from "../components/Buttons/NewButton";
import AddDeviceModal from "../components/Modals/AddDeviceModal";

const DevicesWIPMobile = ({}) => {
	const MOBILE = useIsMobile();
	const { t } = useTranslation();
	const [toggleDrag, setToggleDrag] = useState(false);
	const [createGroup, setCreateGroup] = useState(false);
	const [groupsVisible, setGroupsVisible] = useState(false);
	const [deviceList, setDeviceList] = useState(null);
	const [groupListFull, setGroupListFull] = useState(null);
	const [groupList, setGroupList] = useState(null);
	const [loading, setLoading] = useState(true);
	const [showActions, setShowActions] = useState(false);
	const [allSelected, setAllSelected] = useState(false);
	const [currentDevice, setCurrentDevice] = useState(null);
	const [sorting, setSorting] = useState({ type: "status", order: "desc" });
	const [searchText, setSearchText] = useState("");
	const [initialLoad, setInitialLoad] = useState(false);
	const [openGroupId, setOpenGroupId] = useState(null);
	const [transition, setTransition] = useState(false);
	const [sortOrder, setSortOrder] = useState("status_asc");
	const [groupFilter, setGroupFilter] = useState([]);
	const [groupSelected, setGroupSelected] = useState("-1");
	const [searchWord, setSearchWord] = useState("");
	const [detailReady, setDetailReady] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const [selectedGroup, setSelectedGroup] = useState(null)
	const { setActionbarContent, setTopbarContent } = useSidebarContext();
	const isDetailVisible = !!currentDevice && !groupsVisible;

	const [toggles, setToggles] = useState({
		relay: false,
		override: false,
		engineblock: false,
	});
	const [permissions, setPermissions] = useState({
		override: false,
		engineblock: false,
	});
	const [modals, setModals] = useState({
		add_device: false,
		create_group: false,
		override: false,
		groups: false,
	});

	useEffect(() => {
		fetchData();
		setActionbarContent(null)
		setTopbarContent(null)
		return () => {
			setActionbarContent(null)
			setTopbarContent(null)
		}
	}, []);

	useEffect(() => {
		if(location.state && location?.state?.devId){
			setCurrentDevice(null)
			setCurrentDevice(location?.state?.devId)
			navigate(location.pathname, { replace: true, state: null });
		}
	}, [location.state])

	const fetchData = async () => {
		await checkToken();
		await getDevices();
		await getGroups();
		await setInitialLoad(true);
	};

	const getDevices = async () => {
		// 1️⃣  If the list hasn’t been loaded, go fetch it
		if (!Array.isArray(deviceList) || deviceList.length === 0) {
			try {
				const { data } = await request.get("devices/list");

				if (data?.errorCode === "10003" || data?.errorCode === "10002") {
					localStorage.clear();
					window.location.href = "login";
					return;
				}
				// 2️⃣  Make sure we always store a *real array* (fallback to [])
				const list = Array.isArray(data?.devices) ? data.devices : [];
				// if(list?.length === 1){
				// 	console.log("DEVVER: ", list[0])
				// 	setCurrentDevice(list[0].id)
				// 	//setCurrentDevice
				// }					
				setDeviceList(list);
			} finally {
				setLoading(false);
			}
			return;
		}
		// 3️⃣  We already have data – copy it
		const sorted = sortListNew(deviceList, sorting);
		setDeviceList(sorted);
		setLoading(false);
	};

	    const addDeviceFunc = (data) => {
            request.post("", "device/create", data).then((response) => {
                if(response.data){
                    if(response.data.error){
                        toast.error(response.data.message)
                    }else{
                        setTimeout(() => {
                            toast.success(t("toast.added"))
                            getDevices()
                            toggleModal("add_device")
                        }, 500);  
                    }
                }
            })
        }

	useEffect(() => {
		filterSearch(searchText);
	}, [searchText, groupsVisible, groupListFull, sorting]);

	useEffect(() => {
		const sorted = sortListNew(deviceList, sorting);
		setDeviceList(sorted);
	}, [sorting]);

	useEffect(() => {
		setLoading(false);
	}, [deviceList]);


	useEffect(() => {
		if(!isDetailVisible){
			const topcontent = {
				left: (
					"burger"
				),
				center: (
					<h4 className="mega-center">{t("devices.devices")}</h4>
				),
				right: (
					<NewButton notext={true} className="full-rounded menu-button bg-white" icon={icons.plus} iconClass={"size_20 primary-icon"} onClick={() => toggleModal("add_device")} />
				)
			}
			setTopbarContent(topcontent)
		}
	}, [isDetailVisible])

	const updateData = useCallback(() => {
		if (currentDevice) return;
		request.get("devices/list").then((response) => {
			if(response?.data?.error === "Missing flavor"){
				localStorage.clear();
				window.location.href = "login";
			}
			if (!response || !response?.data || response?.data?.error) return;

			const newData = Array.isArray(response?.data?.devices) ? response.data.devices : [];
			const oldData = Array.isArray(deviceList) ? deviceList : [];
			const oldById = new Map(oldData.map((d) => [d.id, d]));

			// Use server list as the source of truth, but preserve local flags like "selected".
			const merged = newData.map((device) => {
				const old = oldById.get(device.id);
				return old ? { ...device, selected: old.selected } : device;
			});

			const sorted = sortListNew(merged, sorting);
			//const hasChanged = JSON.stringify(sorted) !== JSON.stringify(oldData);
			//if (hasChanged) setDeviceList(sorted || []);
			setDeviceList(sorted || []);

		});
	}, [deviceList, sorting]);

	useIntervalWhenVisible(updateData, 10_000, initialLoad && !currentDevice);

	const sortGroups = (list) => {
		const ascending = (sorting.order ?? "asc") === "asc";
		if (!Array.isArray(list) || list.length === 0) return [];
		return [...list].sort((a, b) => {
			let valA = a?.["name"];
			let valB = b?.["name"];

			// Handle null/undefined
			if (valA == null && valB != null) return ascending ? -1 : 1;
			if (valA != null && valB == null) return ascending ? 1 : -1;
			if (valA == null && valB == null) return 0;

			// String comparison (case-insensitive)
			const strA = valA.toString().toLowerCase();
			const strB = valB.toString().toLowerCase();
			if (strA < strB) return ascending ? -1 : 1;
			if (strA > strB) return ascending ? 1 : -1;
			return 0;
		});
	};

	// const sortList = (list) => {
	// 	const type = sorting.type;
	// 	const ascending = (sorting.order ?? "asc") === "asc";
	// 	if (type === "groups") {
	// 		const sortedGroups = sortGroups(groupListFull);
	// 		setGroupList(sortedGroups);
	// 	}

	// 	if (!Array.isArray(list) || list.length === 0) return [];
	// 	return [...list].sort((a, b) => {
	// 		let valA = a?.[type];
	// 		let valB = b?.[type];

	// 		// Handle null/undefined
	// 		if (valA == null && valB != null) return ascending ? -1 : 1;
	// 		if (valA != null && valB == null) return ascending ? 1 : -1;
	// 		if (valA == null && valB == null) return 0;

	// 		// Handle date comparison
	// 		if (type === "lastupdate") {
	// 			valA = new Date(valA);
	// 			valB = new Date(valB);
	// 			if (valA < valB) return ascending ? -1 : 1;
	// 			if (valA > valB) return ascending ? 1 : -1;
	// 			return 0;
	// 		}

	// 		// String comparison (case-insensitive)
	// 		const strA = valA.toString().toLowerCase();
	// 		const strB = valB.toString().toLowerCase();
	// 		if (strA < strB) return ascending ? -1 : 1;
	// 		if (strA > strB) return ascending ? 1 : -1;
	// 		return 0;
	// 	});
	// };

	const getGroups = () => {
		request.get("device/group/list").then((response) => {
			if (response.data && !response?.data?.error) {
				setGroupListFull(response.data);
				setGroupList(response.data);
			}
		});
	};

	const selectedDevice = useMemo(() => {
		if (!currentDevice || !Array.isArray(deviceList)) return null;
		return deviceList.find((d) => d.id === currentDevice) ?? null;
	}, [currentDevice, deviceList]);

	const toggleModal = (modalName) => {
		setModals((prevState) => ({
			...prevState,
			[modalName]: !prevState[modalName],
		}));
	};

	const filterSearch = (text) => {
		if (text === "" || text === null) {
			const sorted = sortListNew(deviceList, sorting);
			setSearchText("");
			setDeviceList(sorted);
			return;
		}
		if (groupsVisible) {
			const match = groupListFull?.filter((group) => {
				const item = text.toLowerCase();
				return group.name.toLowerCase().indexOf(item) > -1;
			});
			setGroupList(match);
			return;
		}
		const match = deviceList?.filter((device) => {
			const item = text.toLowerCase();
			return device.name.toLowerCase().indexOf(item) > -1 || device.uniqueid.toLowerCase().indexOf(item) > -1;
		});
		const sorted = sortListNew(match, sorting);
		setDeviceList(sorted);
		setSearchText(text);
	};
	
	const closeSelectedDevice = () => {
		setCurrentDevice(null);
		updateData();
	};

	const submitOverride = () => {};

	const selectDevice = (e, id) => {
		e.stopPropagation();
		const updatedDeviceList = [...deviceList];
		const index = updatedDeviceList?.findIndex((device) => device.id === id);
		const match = updatedDeviceList[index];

		if (match?.iotinfo?.model?.id !== 10) {
			toast.error(t("devices.model_not_supported"));
			return;
		}
		if (match.selected !== true) {
			match.selected = true;
		} else {
			match.selected = false;
		}
		updatedDeviceList[index] = match;
		setDeviceList(updatedDeviceList);
	};

	const refreshDevices = async () => {
		try {
			const { data } = await request.get("devices/list");

			if (data?.errorCode === "10003" || data?.errorCode === "10002") {
				localStorage.clear();
				window.location.href = "login";
				return;
			}

			// 2️⃣  Make sure we always store a *real array* (fallback to [])
			const list = Array.isArray(data?.devices) ? data.devices : [];

			setDeviceList(list);
		} finally {
			setLoading(false);
		}
	};

	const renderActions = () => {
		const handleToggle = (type) => {
			setToggles((prev) => ({
				relay: type === "relay" ? !prev.relay : false,
				override: type === "override" ? !prev.override : false,
				engineblock: type === "engineblock" ? !prev.engineblock : false,
			}));
		};
		const actions = [];

		if (FLAVOR !== "alco") {
			actions.push({
				key: "relay",
				enabled: true,
				label: t("devices.enable_disable_power"),
				active: toggles.relay,
			});
		} else {
			if (permissions?.engineblock) {
				actions.push({
					key: "engineblock",
					enabled: true,
					label: t("devices.engine_block"),
					active: toggles.engineblock,
				});
			}
			if (permissions?.override) {
				actions.push({
					key: "override",
					enabled: true,
					label: t("devices.override_alco"),
					active: toggles.override,
				});
			}
		}

		return (
			<Card className="py-0 px-1 mt-1 mb-2">
				<div className="d-flex flex-row justify-content-between align-items-center px-1 pt-3 pb-2 border-bottom">
					<h4 className="mb-2">{t("devices.actions")}</h4>
					<img className="mb-2 size_25 cursor-pointer close_img" src={icons.close_gray} onClick={() => setShowActions(!showActions)} alt="..." />
				</div>
				<ul className="list-group list-group-flush">
					{actions.map((action) => (
						<li key={action.key} className={`cursor-pointer list-group-item d-flex justify-content-between align-items-center ${!action.enabled ? "d-none" : ""}`} onClick={() => handleToggle(action.key)}>
							<p className={`my-2 ${action.active ? "primary bold" : "dark_grey"}`}>{action.label}</p>
						</li>
					))}
				</ul>
			</Card>
		);
	};

	const checkChecked = () => {
		const checkedDevices = deviceList?.filter((device) => device.selected).map((device) => device.id);
		return checkedDevices;
	};

	const closeActions = () => {
		setToggles({
			relay: false,
			override: false,
			engineblock: false,
		});
		setShowActions(false);
	};

	const actionMap = {
		relay: {
			text: t("devices.toggle_relay"),
			handler: () => console.log(checkChecked()),
		},
		override: {
			text: t("devices.toggle_override"),
			handler: () => toggleModal("override"),
		},
		engineblock: {
			text: t("devices.toggle_engineblock"),
			handler: () => alert("Engine-block action"),
		},
	};

	const getActiveKey = (obj) => {
		return Object.keys(obj).find((k) => obj[k]);
	};

	const actionText = () => {
		const key = getActiveKey(toggles);
		return key ? actionMap[key].text : "Select action";
	};

	const handleAction = () => {
		const key = getActiveKey(toggles);
		if (!key) return; // nothing selected
		actionMap[key].handler(); // run the mapped callback
	};

	useEffect(() => {
		// bail out if list hasn't been loaded yet
		if (!Array.isArray(deviceList)) return;

		setDeviceList((prev) =>
			prev.map((device) => ({
				...device,
				selected: allSelected
					? device?.modelspecificinfo?.id === 10 // only true for id 10
					: false, // else clear all
			}))
		);
	}, [allSelected]);

	const hideCheckbox = !toggles.relay && !toggles.override && !toggles.engineblock;
	const showBtns = toggles.relay || toggles.override || toggles.engineblock;
	const allDevicesSelected = deviceList && !deviceList.some((device) => !device.selected);

	const DeviceListSection = () => {
		if (loading) return <DeviceRowPlaceholder />;
		if (groupsVisible || sortOrder === "groups") return null;
		let filteredDevices = deviceList || [];

		if (searchWord.trim() !== "") {
			const search = searchWord.toLowerCase();
			filteredDevices = filteredDevices.filter((device) => device.name.toLowerCase().includes(search) || device.uniqueid.toLowerCase().includes(search));
		}

		if (groupSelected !== "-1" && groupSelected !== null && groupSelected !== "-1337") {
			const selectedGroupIds = groupListFull?.find((group) => group.id === parseInt(groupSelected))?.deviceId || [];
			filteredDevices = filteredDevices.filter((device) => selectedGroupIds.includes(device.id));
		}

		const sortedDevices = sortListNew(filteredDevices);
		return (
			<>
				{sortedDevices?.length === 0 && !loading  &&
					<h3 className="bold dark-grey text-center mt-5">{t("devices.no_devices")}</h3>
				}
				{sortedDevices?.map((device, index) => (
					<DeviceRowNew
						key={device.id}
						device={device}
						index={index}
						sorting={sorting}
						currentDevice={currentDevice}
						setCurrentDevice={setCurrentDevice}
						deviceListLength={filteredDevices.length}
						checkboxVisibility={toggles.relay || toggles.override || toggles.engineblock}
						setDeviceToggle={(e, id) => selectDevice(e, id)}
					/>
				))}
			</>
		);
	};

	const GroupSortedSection = () => {
		if (loading) return <DeviceRowPlaceholder />;
		if (groupsVisible) return null;
		if (sortOrder !== "groups") return null;
		return (
			<div className="d-flex flex-column position-relative">
				{groupList?.length === 0 && !loading  &&
					<h3 className="bold dark-grey text-center mt-5">{t("devices.no_devices")}</h3>
				}
				{groupList.map((group, index) => {
					// Find devices that belong to this group
					const devicesInGroup = deviceList.filter((device) => group.deviceId.includes(device.id));
					return (
						<div className={`${index !== 0 ? "pt-0" : ""}`} key={index}>
							<div className={`d-flex w-100 p-1 px-2 groupheader glossy-nocolor`}>
								<h4 className="m-0">{group.name}</h4>
							</div>
							<div className="rounded24 overflow-hidden">
							{devicesInGroup?.length === 0 && !loading  &&
								<h3 className="bold dark-grey text-center mt-5">{t("devices.no_devices")}</h3>
							}
							{devicesInGroup.length > 0 &&
								devicesInGroup.map((device, index) => (
									<DeviceRowNew
										key={device.id}
										device={device}
										index={index}
										sorting={sorting}
										currentDevice={currentDevice}
										setCurrentDevice={setCurrentDevice}
										refresh={refreshDevices}
										deviceListLength={deviceList.length}
										checkboxVisibility={toggles.relay || toggles.override || toggles.engineblock}
										setDeviceToggle={(e, id) => selectDevice(e, id)}
									/>
	
								))}
							</div>

						</div>
					);
				})}
			</div>
		);
	};

const selectedDeviceSection = () => {

  return (
	<SelectedDevice
		deviceId={currentDevice}
		refresh={refreshDevices}
		closeDevice={closeSelectedDevice} // your handleClose calls this
		onReady={(r) => setDetailReady(r)}          // 👈 from child getInfo
		onCloseStart={() => setDetailReady(false)}  // 👈 start list return immediately
	/>
    );

};

	const updateGroup = (obj) => {
		request.post("", "device/group/update", obj).then((response) => {
			if (response.data.successful) {
				fetchData();
				toggleModal("groups")
				toast.success(t("toast.success"));
			} else {
				const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
			}
		});
	};

	const deleteGroup = (id) => {
		const data = { groupid: id };
		request.post("", "device/group/delete", data).then((response) => {
			if (response.data.successful) {
				toast.success(t("toast.success"));
				fetchData();
				toggleModal("groups")
				setGroupSelected("-1")

			} else {
				const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
			}
		});
	};

	const saveGroup = async(obj) => {

		await request.post("", "device/group/create", obj).then((response) => {
			if (response.data.successful) {
				fetchData();
				toggleModal("groups");
				setGroupSelected(response?.data?.groupid)
				toast.success(t("toast.success"));
			} else {
				const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
			}
		});
	};

	useEffect(() => {
		if (!groupsVisible) {
			setCreateGroup(false);
		}
	}, [groupsVisible]);

	const GroupSection = () => {
		if (!groupsVisible) return null;
		if (createGroup) {
			return <CreateGroup groups={groupList} devices={deviceList} setCreateGroup={() => setCreateGroup(!createGroup)} saveGroup={(name, devices) => saveGroup(name, devices)} />;
		} else {
			return groupList?.map((group, index) => <GroupRow setOpenGroupId={setOpenGroupId} isOpen={group.id === openGroupId} group={group} outerDevices={deviceList} editGroup={(data) => updateGroup(data)} deleteGroup={(data) => deleteGroup(data)} index={index} key={group.id} />);
		}
	};

	useEffect(() => {
		if(groupSelected === "-1337"){
			//setGroupsVisible(true)
			toggleModal("groups")
			setGroupSelected("-1")
		}
	}, [groupSelected])



	useEffect(() => {
		if (!groupListFull) return;
		const fixed = [{ label: t("devices.all_devices"), value: "-1" }];

		const mappedGroups = groupListFull?.map((group) => ({
			label: group.name,
			value: group.id.toString(), // or keep as number if preferred
		}));
		const add = [{ label: t("devices.add_group"), value: "-1337" }];

		const matched = [...fixed, ...mappedGroups, ...add];
		setGroupFilter(matched);
	}, [groupListFull]);

	// sortOrder can be: "name_asc" | "name_desc" | "status" | "groups" (and optional lastupdate_*)
	// devices: [{ id, name, status: "online"|"offline", lastupdate?: string }]

	const sortListNew = (list) => {
		if (!Array.isArray(list) || list.length === 0) return [];

		switch (sortOrder) {
			case "name_asc":
				return [...list].sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", undefined, { sensitivity: "base" }));

			case "name_desc":
				return [...list].sort((a, b) => (b.name ?? "").localeCompare(a.name ?? "", undefined, { sensitivity: "base" }));

			case "status_asc": {
				// "online" first, "offline" after, then sort by name ASC
				const rank = { online: 0, offline: 1 };
				return [...list].sort((a, b) => {
					const ra = rank[(a.status || "").toLowerCase()] ?? 99;
					const rb = rank[(b.status || "").toLowerCase()] ?? 99;

					// First compare by status
					if (ra !== rb) return ra - rb;

					// Then compare by name (A–Z)
					return (a.name ?? "").localeCompare(b.name ?? "", undefined, { sensitivity: "base" });
				});
			}
			case "updated": {
				return [...list].sort((a, b) => {
					return new Date(b.lastupdate).getTime() - new Date(a.lastupdate).getTime();
				})

			}

			default:
				return list;
		}
	};

	const listVariants = {
		base: { 
			x: "0", 
			opacity: 1, 
			pointerEvents: "auto",
		},
		pushed: { 
			x: "-120%", 
			opacity: 1, 
			pointerEvents: "none",
			position: "absolute",
		},
	};
	const isBike = FLAVOR === "bike";

	return (
		<>
			<div className="info-section scrollable-y" id="resizable-element">
				<AnimatePresence mode="sync">
				<motion.div
					className={`${isDetailVisible && detailReady ? "mt-4" : ""} d-flex mb-2 justify-content-${FLAVOR !== "bike" ? "between": "end"} margin-x-20 mt-3`}
					key="btns"
					variants={listVariants}
					initial={"base"}
					animate={isDetailVisible && detailReady ? "pushed" : "base"}  // 👈 wait for ready
					transition={{ duration: 0.25, ease: "easeOut" }}
				>
					{FLAVOR !== "bike" &&
					<div className="d-flex flex-row flex-fill">
						<div className="select-wrap">
							<select value={groupSelected} onChange={(e) => setGroupSelected(e.target.value)} className="bg-white form-control text-truncate height36 full-rounded">
								{groupFilter.map((group, index) => (
									<option key={index} value={group.value}>
										{group.label}
									</option>
								))}
							</select>
						</div>
						{groupSelected && groupSelected !== "-1" &&
							<div onClick={() => toggleModal("groups")} className="cursor-pointer ms-2 full-rounded btn-search d-flex justify-content-center align-items-center bg-grey">
								<img src={icons.cog} className="size_15 dark-grey-icon" alt="cog"/>
							</div>
						}
		
					</div>
					}

					<div className="d-flex">
						<div className="mx-2">
							<SearchbarNew submitSearch={(data) => setSearchWord(data)} />
						</div>
						<div className="bg-white full-rounded">
							<select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} className="btn-search full-rounded sort-select cursor-pointer">
								<option value="name_asc">{t("devices.name_asc")}</option>
								<option value="name_desc">{t("devices.name_desc")}</option>
								<option value="status_asc">{t("devices.status")}</option>
								<option value="updated">{t("devices.updated")}</option>
								{FLAVOR !== "bike" && <option value="groups">{t("devices.groups")}</option>}
								{/* <option value="date_desc">Date (Newest)</option> */}
							</select>
						</div>
					</div>
				</motion.div>
				<motion.div 
					key="lists"
					className={`${isDetailVisible && detailReady ? "mt-5" : ""} rounded24 margin-x-20 ${showBtns ? "pushed" : ""} margin-bottom-20`}
					variants={listVariants}
					initial="base"
					animate={isDetailVisible && detailReady ? "pushed" : "base"}  // 👈 wait for ready
					transition={{ duration: 0.25, ease: "easeOut" }}
				>
					<div className="rounded24 overflow-hidden">
					<DeviceListSection />
					<GroupSortedSection />
					<GroupSection />
					</div>
				</motion.div>

				{isDetailVisible && (
				<div className={`${!detailReady ? "d-none": ""} rounded24 ${showBtns ? "pushed" : ""} margin-bottom-20`}>
					<motion.div
						key={`selected-${currentDevice}`}
						initial={{ x: "100%", opacity: 0 }}
						className={`${!MOBILE ? "margin-x-20" : ""} rounded24 overflow-hidden`}
						animate={detailReady ? { x: 0, opacity: 1 } : { x: "100%", opacity: 1}} // 👈 don’t enter until ready
						exit={{ x: "100%", opacity: 0 }}
						transition={{ duration: 0.25, ease: "easeOut" }}
						style={{ zIndex: 5 }}
					>
						{selectedDeviceSection()}
					</motion.div>
				</div>
				)}
				</AnimatePresence>

				{showBtns && (
					<div className={`d-flex justify-content-end mt-3`}>
						<Button btnClass="btn-secondary me-3" onClick={() => closeActions()}>
							{t("devices.cancel")}
						</Button>
						<Button btnClass={`btn-primary ${checkChecked()?.length === 0 ? "disabled" : ""}`} onClick={() => handleAction()}>
							{actionText()}
						</Button>
					</div>
				)}
			</div>
				<AddDeviceModal 
					show={modals["add_device"] ?? false} 
					type={"add_device"} 
					onClose={() => toggleModal("add_device")} 
					onSave={(data) => addDeviceFunc(data)}
					sharableDevices={[]} 
					updateDevices={() => getDevices()} />
			<OverrideModal show={modals.override} onClose={() => toggleModal("override")} save={(data) => submitOverride(data)} />
			<GroupModal show={modals.groups ?? false} groupList={groupList} devices={deviceList} groupSelected={groupSelected} type={groupSelected && groupSelected !== "-1" ? "edit" : "create"} onClose={() => toggleModal("groups")}  handleDelete={(id) => deleteGroup(id)} save={(data) => groupSelected && groupSelected !== "-1" ? updateGroup(data) : saveGroup(data)} />
			{/* <EngineBlockModal show={modals.engine_block} onClose={() => toggleModal("engine_block")} save={(data) => submitEngineBlock(data) } /> */}
		</>
	);
};

export default DevicesWIPMobile;
